import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * Opportunita formative — usa le API /safety/agenzie gia' autorizzate in auth.json
 * (evita ACCESS_DENIED finche' non si deployano le route /safety/opportunita/*).
 */
export default class SafetyOpportunitaService {
    static getRiepilogo = async () => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/agenzie`;
        const resp = await ApiService.getRudeRequest(url);
        const data = resp && typeof resp.json === "function" ? await resp.json() : resp;
        const agenzie = Array.isArray(data) ? data : [];
        return {
            agenzie,
            totale_con_esigenze: agenzie.filter((a) => a.ha_esigenze).length,
        };
    };

    static getDettaglioAgenzia = (id_agenzia, params = {}) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/agenzie/show`;
            ApiService.postRequest(resolve, reject, url, {
                id_agenzia,
                include_scadenze_formative: 1,
                soglia_giorni: params.soglia_giorni ?? 90,
            });
        });
    };
}
